/** Internal type. DO NOT USE DIRECTLY. */
import { gql } from "@apollo/client"

import * as Types from "../../../shared/types/__generated__/graphql"

export type Incremental<T> =
  | T
  | {
      [P in keyof T]?: P extends " $fragmentName" | "__typename" ? T[P] : never
    }

export type ClarificationRequestFragment = {
  __typename: "ClarificationRequest"
  id: string
  content: string
  createdAt: string
  updatedAt: string
  lastUpdatedBy?: {
    __typename: "User"
    id: string
    name?: string | null
    email: string
    createdAt: string
    updatedAt: string
  } | null
}

export const ClarificationRequestFragmentDoc = gql`
  fragment ClarificationRequest on ClarificationRequest {
    id
    content
    createdAt
    updatedAt
    lastUpdatedBy @type(name: "User") {
      id
      name
      email
      createdAt
      updatedAt
    }
  }
`
